<script>
export default {
  name: 'NotificationInfo',
  data () {
    return {
    }
  },
  props: ['html'],
  methods: {

  },
  created () {
  }
}
</script>

<template>
  <div style="width: 100%;padding: 8px 16px;">
    <div v-html="html"></div>
  </div>
</template>

<style scoped>

</style>
